let sides = [
    {
        title: "",
        content: "side.side0.content",
        imagePath: "https://i.imgur.com/8ANIL2D.jpg"
    },
    {
        title: "ORTEC and the fun of algorithmic programming! Powered by ORTEC",
        content: "side.side1.content",
        imagePath: "https://i.imgur.com/P27Gfbu.png"
    },
    {
        title: "Ignite Your Automation! Powered by UiPath",
        content: "side.side2.content",
        imagePath: "https://i.imgur.com/vPEPC4O.png"
    },
    {
        title: "CodeFest BCR 26 Martie 2019 – Code to the Clouds!",
        content: "side.side3.content",
        imagePath: "https://i.imgur.com/8YppQVd.png"
    },
    {
        title: "Why Save your energy?",
        content: "side.side4.content",
        imagePath: "https://i.imgur.com/FNtwija.png"
    }
]

let main = {
    title: "",
    content: "about.challenges.main",
    imagePath: "https://i.imgur.com/w87FwS6.png"
}

let side ={
    titlle: "Side Challenges",
    content: "about.challenges.side",
    imagePath: "https://i.imgur.com/8ANIL2D.jpg"
}
  export { sides, main, side };
